export default __webpack_public_path__ + "static/media/raise.cc62aaf2.mp3";